import { config } from '@/config';

const businessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: config.business.name || 'Ashok Telecom & Communication',
  description:
    'Trusted mobile and electronics shop in Tumkur, Karnataka. Smartphones, home & kitchen appliances, Smart TVs, DTH, money transfer, mobile repair, and easy EMI options. Located at Yallapura on Tumkur-Koratagere Highway.',
  url: 'https://ashoktelecom.com/',
  telephone: config.business.phone || '+919964111963',
  email: config.business.email || undefined,
  image: 'https://ashoktelecom.com/images/hero-1.jpg',
  priceRange: '$$',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Shop No. 2, Tumkur-Koratagere Highway, Arakere Post, Yallapura',
    addressLocality: 'Tumakuru',
    addressRegion: 'Karnataka',
    postalCode: '572106',
    addressCountry: 'IN',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '13.3400',
    longitude: '77.1000',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '09:00',
      closes: '21:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Sunday',
      opens: '10:00',
      closes: '14:00',
    },
  ],
  sameAs: [
    config.social.facebookUrl,
    config.social.instagramUrl,
  ].filter(Boolean),
};

export default function LocalBusinessSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(businessSchema) }}
    />
  );
}